// Module
var code = "<div class=\"arrow arrow-prev\" ng-if=\"$ctrl.showArrows\"></div><slick class=\"slick\" settings=\"$ctrl.settings\" dots=\"true\" ng-transclude=\"ng-transclude\"></slick><div class=\"arrow arrow-next\" ng-if=\"$ctrl.showArrows\"></div>";
// Exports
var _module_exports =code;;
var path = '/ng-templates/src/commons/components/jp-slider/jp-slider.tpl.pug';
window.angular.module('ng').run(['$templateCache', function(c) { c.put(path, _module_exports) }]);
module.exports = path;